import React from 'react';
import { FormRow } from './styles';
import DynamicField from './DynamicField';
import { isCampoVisivel } from '../../utils/validation';

const FieldGroup = ({ fields, formData, errors, touched, onChange, onBlur, setErrors }) => {
  // Filtra apenas campos visíveis
  const visibleFields = fields.filter(field => isCampoVisivel(field, formData));
  
  // Agrupa campos em pares (2 por linha)
  const groupedFields = [];
  for (let i = 0; i < visibleFields.length; i += 2) {
    groupedFields.push(visibleFields.slice(i, i + 2));
  }

  return (
    <>
      {groupedFields.map((group, groupIdx) => (
        <FormRow key={groupIdx}>
          {group.map((field, fieldIdx) => (
            <DynamicField
              key={fieldIdx}
              field={field}
              value={formData[field.name]}
              error={errors[field.name]}
              touched={touched[field.name]}
              onChange={onChange}
              onBlur={onBlur}
              formData={formData}
              setErrors={setErrors}
            />
          ))}
        </FormRow>
      ))}
    </>
  );
};

export default FieldGroup;